import { ColumnApi, GridApi, IServerSideGetRowsParams, SortModelItem } from 'ag-grid-community';

export interface TableRequestSnapshot {
  filterModel: Record<string, unknown>;
  sortModel: SortModelItem[];
}

export function buildRequestSnapshot(
  gridApi: GridApi | undefined,
  columnApi: ColumnApi | undefined,
  remapColId?: (colId: string) => string,
): TableRequestSnapshot {
  const sortModel: SortModelItem[] = (columnApi?.getColumnState() ?? [])
    .filter(({ sort }) => !!sort)
    .sort((a, b) => (a.sortIndex ?? 0) - (b.sortIndex ?? 0))
    .map(({ colId, sort }) => ({ colId: remapColId ? remapColId(colId) : colId, sort: sort as SortModelItem['sort'] }));

  return { filterModel: gridApi?.getFilterModel() ?? {}, sortModel };
}

export function applyRequestSnapshot(params: IServerSideGetRowsParams, snapshot: TableRequestSnapshot): IServerSideGetRowsParams {
  return {
    ...params,
    request: {
      ...params.request,
      filterModel: snapshot.filterModel,
      sortModel: snapshot.sortModel,
    },
  };
}
